<template>
    <div class="form-video">
        <div class="modal animated fadeIn">
            <button class="btn-close" @click="closeForm">
                <i class="fa fa-times"></i>
            </button>
            <div class="modal-content">
                <div class="video">
                    <video autoplay id="myVideo" preload="autoplay" controls class="video-js vjs-big-play-centere">
                        <source src="https://res.cloudinary.com/kiubixdev/video/upload/v1533320348/gxsv/Causas_de_accidentes_2018.mp4"
                                v-if="video === 1" type="video/mp4">
                        <source src="https://res.cloudinary.com/kiubixdev/video/upload/v1533320362/gxsv/Consejos_2018.mp4"
                                v-else-if="video === 2" type="video/mp4">
                        <source src="https://res.cloudinary.com/kiubixdev/video/upload/v1533320385/gxsv/Datos_duros_2019.mp4"
                                v-else-if="video === 3" type="video/mp4">
                        <source src="https://res.cloudinary.com/kiubixdev/video/upload/v1533320384/gxsv/PXSV_2018.mp4"
                                v-else-if="video === 4" type="video/mp4">
                        <source src="https://res.cloudinary.com/kiubixdev/video/upload/v1533320364/gxsv/Senales_2018.mp4"
                                v-else-if="video === 5" type="video/mp4">
                        <source src="https://res.cloudinary.com/kiubixdev/video/upload/v1533320356/gxsv/Torero_2018.mp4"
                                v-else-if="video === 6" type="video/mp4">
                        <source src="https://res.cloudinary.com/kiubixdev/video/upload/v1533320365/gxsv/intro_01.mp4"
                                v-else type="video/mp4">
                        Your browser does not support HTML5 video.
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import videojs from 'video.js'
    import 'video.js/dist/video-js.min.css'

    export default {
        name: "form-video-component",
        props: {
            video: {
                type: Number,
                required: true
            }
        },
        mounted() {
            if (this.$store.state.api_token && this.video) {
                this.axios.post('newVisit', {
                    token: this.$store.state.api_token,
                    type: 'VIDEO',
                    name: this.getVideoName()
                })
                    .then(console.info)
                    .catch(console.error)
            }
            const vjs = videojs(document.querySelector('#myVideo'))
        },
        methods: {
            closeForm() {
                this.$emit('close')
            },
            getVideoName() {
                let videos = ['Causas de accidentes', 'Consejos', 'Datos duros', 'PXSV', 'Señales', 'Torero']
                return videos[this.video - 1]
            }
        },
        watch: {
            video() {
                console.log('Video', this.video)
            }
        }
    }
</script>

<style lang="sass" scoped>
    .form-video
        top: 0
        left: 0
        right: 0
        bottom: 0
        position: fixed
        z-index: 9999
        background-color: rgba(0, 0, 0, .6)
        .modal
            background-color: black
            position: fixed
            top: 50%
            left: 50%
            max-width: 90%
            max-height: 90%
            overflow-y: auto
            transform: translate(-50%, -50%)
            border-radius: 10px
            width: 90%
            height: 80%
            box-sizing: border-box
            @media only screen and (max-width: 64em)
                width: 90%
            .btn-close
                background-color: #ff3f46
                color: white
                position: absolute
                top: 5px
                right: 5px
                padding: 5px 9px
                border: none
                text-align: center
                border-radius: 3em
                font-size: 1.2em
                cursor: pointer
                z-index: 1
            .modal-content
                height: 100%
                width: 100%
                overflow: hidden
                .video
                    height: 100%
                    width: 100%
                    .video-js
                        width: 100%
                        height: 100%
                        video
                            max-height: 100%
                            height: 100%
                            max-width: 100%
                            width: 100%
</style>
